module.exports = __webpack_public_path__ + "static/media/adsBtn.57172468.png";